import { yup } from '@framework/validation/initYup.ts';
import { Datatype } from '../../../../expressions/datatype/Datatype.ts';
import { SwitchExpressionSchema } from '../../../../expressions/repository/switch-expression/SwitchExpressionSchema.ts';
import { WidgetType } from '../../../Widget.ts';
import { BaseLayoutSchema } from '../../common/BaseLayoutSchema.ts';
import { CommonInputWidgetConfigSchema } from '../../inputs/common/CommonInputConfigComponent.tsx';
import { type ISwitchWidget } from './ISwitchWidget.ts';

export const SwitchWidgetConfigSchema: yup.ObjectSchema<ISwitchWidget> =
  CommonInputWidgetConfigSchema.shape({
    type: yup.string().exact(WidgetType.Switch).required(),
    expression: SwitchExpressionSchema.required(),
    layout: BaseLayoutSchema.shape({
      hide: yup.boolean().required().default(false).label('Nascondi elemento'),
      removeBorder: yup
        .boolean()
        .required()
        .default(false)
        .label('Rimuovi bordo'),
    }),
    datatype: yup
      .string()
      .required()
      .oneOf([
        Datatype.Number,
        Datatype.Boolean,
        Datatype.Date,
        Datatype.String,
      ])
      .label('Tipo di dato'),
  });
